import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth";

export default function Layout() {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "agency_admin";

  return (
    <div className="shell">
      <header className="topnav">
        <div className="brand">
          Marketing <span>Intelligence</span>
        </div>
        <nav>
          {isAdmin && (
            <>
              <NavLink to="/portfolio" className={({ isActive }) => isActive ? "active" : ""}>Portfolio</NavLink>
              <NavLink to="/alerts" className={({ isActive }) => isActive ? "active" : ""}>Alerts</NavLink>
              <NavLink to="/recommendations" className={({ isActive }) => isActive ? "active" : ""}>Recommendations</NavLink>
              <NavLink to="/geo-leaderboard" className={({ isActive }) => isActive ? "active" : ""}>GEO</NavLink>
              <NavLink to="/errors" className={({ isActive }) => isActive ? "active" : ""}>Errors</NavLink>
              <NavLink to="/onboard" className={({ isActive }) => isActive ? "active" : ""}>Onboard client</NavLink>
            </>
          )}
          {!isAdmin && user?.client_id && (
            <>
              <NavLink to={`/my/${user.client_id}`} end className={({ isActive }) => isActive ? "active" : ""}>My Marketing</NavLink>
              <NavLink to={`/my/${user.client_id}/history`} className={({ isActive }) => isActive ? "active" : ""}>Past Reports</NavLink>
            </>
          )}
        </nav>
        <div className="user">
          <span>{user?.email}</span>
          <button className="secondary" onClick={logout}>Log out</button>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
